import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MobileStateService {
  #windowResize = new BehaviorSubject<boolean>(this.#isMobile);
  get windowResize(): Observable<boolean> {
    return this.#windowResize.asObservable();
  }
  get #isMobile(): boolean {
    return window.innerWidth < 600;
  }

  constructor() {
    window.addEventListener('resize', () => {
      /*
        to reduce the amount of subscription spam this could produce we only want to only trigger `.next()` when the state actually changes. As well
        this allows us to more reliably do operations when we 'switch' from mobile to desktop instead of having to double check on each subscription.
      */
      if (this.#windowResize.value !== this.#isMobile) {
        this.#windowResize.next(this.#isMobile);
      }
    });
  }
}
